<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-dialog" role="document">
      <div class="modal-content radius-8 px-4">
        <div class="text-center">
          <h3 class="modal-title mb-8" id="cancelModalLabel">Cancel Order</h3>
          <p class="modal-text">Are you sure you want to cancel the order?</p>

          <div class="d-flex flex-column justify-content-center max-280 mt-2">
            <a href="#" class="btn primary-btn px-1">Yes, Proceed</a>

            <button type="button" class="btn modal-secondary-btn no-btn close mt-2" @click="closeModal" aria-label="Close">Back to Order</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      currentUser: {
        type: Object,
        required: true
      },
      customer: {
        type: Object,
        required: true
      },
      vendor: {
        type: Object,
        required: true
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      }
    }
  };
</script>
